import React from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
const SavingsSectionV3 = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="savings">
      <h2>
        {t('How to use label')}&nbsp;<span>SingleCare</span>
      </h2>
      <ul className="steps desktop-only">
        <li className="step1">
          <div className="stepImg">
            <LazyLoadImage
              src="/content/images/homepagev2/step1-1.svg"
              alt=""
              width="67px"
              height="78px"
            />
          </div>
          <h3>1. {t('Search prescriptions')}</h3>
          <p>{t('para step1')}</p>
        </li>
        <li className="step2">
          <div className="stepImg">
            <LazyLoadImage
              src="/content/images/homepagev2/step2-2.svg"
              alt=""
              width="92px"
              height="86px"
            />
          </div>
          <h3>2. {t('Choose a free coupon label')}</h3>
          <p>{t('para step2')}</p>
        </li>
        <li className="step3">
          <div className="stepImg">
            <LazyLoadImage
              src="/content/images/homepagev2/step3-3.svg"
              alt=""
              width="76px"
              height="88px"
            />
          </div>
          <h3>3. {t('Show your pharmacist')}</h3>
          <p>{t('para step3')}</p>
        </li>
      </ul>

      <div className="mobile-only">
        <ul className="steps">
          <li className="step1">
            <div className="stepImg">
              <LazyLoadImage
                src="/content/images/homepagev2/step1-1.svg"
                alt=""
                width="90px"
                height="90px"
              />
            </div>
          </li>
          <li className="leftLine"></li>
          <li className="step2">
            <div className="stepImg">
              <LazyLoadImage
                src="/content/images/homepagev2/step2-2.svg"
                alt=""
                width="90px"
                height="90px"
              />
            </div>
          </li>
          <li className="rightLine"></li>
          <li className="step3">
            <div className="stepImg">
              <LazyLoadImage
                src="/content/images/homepagev2/step3-3.svg"
                alt=""
                width="90px"
                height="90px"
              />
            </div>
          </li>
        </ul>
        <ul className="stepPoint">
          <li>1. {t('Search prescriptions')}</li>
          <li>2. {t('Choose a free coupon label')}</li>
          <li>3. {t('Show your pharmacist')}</li>
        </ul>
      </div>

      <div className="learnMoreLink">
        <a href={_.withLocale(i18n.language, '/how-it-works')}>
          {t('Learn more link')}
        </a>
      </div>
    </section>
  );
};

export default SavingsSectionV3;
